<template>
  <ContentWrap>
    <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      title="配置合伙人加盟页的权益档位：名称、价格、折扣、主题、速览标签与权益明细；C 端实时读取启用中的档位。"
    />
    <el-button v-hasPermi="['bosscircle:partner-tier:update']" type="primary" @click="open()">
      <Icon class="mr-5px" icon="ep:plus" />新增档位
    </el-button>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column prop="code" label="编码" width="90" />
      <el-table-column prop="badge" label="徽章" width="80" />
      <el-table-column prop="name" label="名称" min-width="100" />
      <el-table-column label="充值金额" width="120">
        <template #default="{ row }">¥{{ formatYuan(row.priceYuan) }}</template>
      </el-table-column>
      <el-table-column label="折扣" width="90">
        <template #default="{ row }">{{ row.discount != null ? row.discount + '折' : '-' }}</template>
      </el-table-column>
      <el-table-column label="主题" width="100">
        <template #default="{ row }">
          <dict-tag :type="DICT_TYPE.BOSSCIRCLE_PARTNER_THEME" :value="row.theme" />
        </template>
      </el-table-column>
      <el-table-column prop="rank" label="权重" width="70" />
      <el-table-column prop="sortOrder" label="排序" width="70" />
      <el-table-column label="速览" min-width="160" show-overflow-tooltip>
        <template #default="{ row }">{{ (row.highlightLabels || []).join('、') }}</template>
      </el-table-column>
      <el-table-column label="权益数" width="80">
        <template #default="{ row }">{{ (row.benefits || []).length }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template #default="{ row }">
          <dict-tag :type="DICT_TYPE.COMMON_STATUS" :value="row.status" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template #default="{ row }">
          <el-button
            v-hasPermi="['bosscircle:partner-tier:update']"
            link
            type="primary"
            @click="open(row)"
          >
            编辑
          </el-button>
          <el-button
            v-hasPermi="['bosscircle:partner-tier:delete']"
            link
            type="danger"
            @click="remove(row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </ContentWrap>

  <Dialog v-model="visible" :title="form.id ? '编辑档位' : '新增档位'" width="760px">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item label="编码" prop="code">
            <el-input v-model="form.code" maxlength="16" placeholder="如 v1" :disabled="!!form.id" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="徽章" prop="badge">
            <el-input v-model="form.badge" maxlength="16" placeholder="如 V1" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name" maxlength="32" placeholder="如 探索者" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="充值金额" prop="priceYuan">
            <el-input-number v-model="form.priceYuan" :min="0.01" :precision="2" class="!w-full" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务折扣" prop="discount">
            <el-input-number
              v-model="form.discount"
              :min="0.1"
              :max="10"
              :precision="1"
              :step="0.5"
              class="!w-full"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主题" prop="theme">
            <el-select v-model="form.theme" class="w-full" placeholder="请选择主题">
              <el-option
                v-for="item in themeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="权重" prop="rank">
            <el-input-number v-model="form.rank" :min="0" class="!w-full" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排序" prop="sortOrder">
            <el-input-number v-model="form.sortOrder" :min="0" class="!w-full" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio
                v-for="item in statusOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="权益速览">
            <div class="w-full">
              <div
                v-for="(_label, idx) in form.highlightLabels"
                :key="'hl-' + idx"
                class="mb-8px flex gap-8px"
              >
                <el-input v-model="form.highlightLabels![idx]" maxlength="16" placeholder="如 服务折扣" />
                <el-button link type="danger" @click="form.highlightLabels!.splice(idx, 1)">删除</el-button>
              </div>
              <el-button
                v-if="(form.highlightLabels || []).length < 8"
                link
                type="primary"
                @click="form.highlightLabels!.push('')"
              >
                + 添加标签
              </el-button>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="权益明细">
            <div class="w-full">
              <div
                v-for="(item, idx) in form.benefits"
                :key="'bf-' + idx"
                class="mb-10px rounded border border-[var(--el-border-color)] p-10px"
              >
                <el-input v-model="item.title" class="mb-8px" maxlength="64" placeholder="权益标题" />
                <el-input v-model="item.desc" maxlength="128" placeholder="说明（选填）" />
                <el-button class="mt-6px" link type="danger" @click="form.benefits!.splice(idx, 1)">
                  删除本条
                </el-button>
              </div>
              <el-button link type="primary" @click="form.benefits!.push({ title: '', desc: '' })">
                + 添加权益
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="saving" @click="save">保存</el-button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import type { FormInstance, FormRules } from 'element-plus'
import {
  DICT_TYPE,
  getIntDictOptions,
  getStrDictOptions,
} from '@/utils/dict'
import * as Api from '@/api/business/partnerTier'
import type { PartnerTierVO } from '@/api/business/partnerTier'

defineOptions({ name: 'BossCirclePartnerTier' })

const message = useMessage()
const loading = ref(false)
const saving = ref(false)
const visible = ref(false)
const list = ref<PartnerTierVO[]>([])
const formRef = ref<FormInstance>()
const themeOptions = getStrDictOptions(DICT_TYPE.BOSSCIRCLE_PARTNER_THEME)
const statusOptions = getIntDictOptions(DICT_TYPE.COMMON_STATUS)

const emptyForm = (): PartnerTierVO => ({
  code: '',
  name: '',
  badge: '',
  priceYuan: 10000,
  discount: 9.5,
  theme: 'blue',
  rank: 1,
  highlightLabels: ['服务折扣', '会员社群', '高端沙龙', '推荐奖励', '更多权益'],
  benefits: [{ title: '', desc: '' }],
  sortOrder: 0,
  status: 0,
})

const form = reactive<PartnerTierVO>(emptyForm())

const rules: FormRules = {
  code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
  name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
  priceYuan: [{ required: true, message: '请输入金额', trigger: 'change' }],
  theme: [{ required: true, message: '请选择主题', trigger: 'change' }],
  rank: [{ required: true, message: '请输入权重', trigger: 'change' }],
  status: [{ required: true, message: '请选择状态', trigger: 'change' }],
}

const formatYuan = (n: number) =>
  Number(n || 0).toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })

const load = async () => {
  loading.value = true
  try {
    list.value = (await Api.getPartnerTierList()) || []
  } finally {
    loading.value = false
  }
}

const open = (row?: PartnerTierVO) => {
  Object.assign(form, emptyForm(), row || {})
  form.highlightLabels = [...(row?.highlightLabels || emptyForm().highlightLabels || [])]
  form.benefits = (row?.benefits || []).map((b) => ({ title: b.title || '', desc: b.desc || '' }))
  if (!form.benefits.length) form.benefits = [{ title: '', desc: '' }]
  visible.value = true
  nextTick(() => formRef.value?.clearValidate())
}

const save = async () => {
  await formRef.value?.validate()
  saving.value = true
  try {
    const payload: PartnerTierVO = {
      ...form,
      code: String(form.code || '').trim().toLowerCase(),
      highlightLabels: (form.highlightLabels || []).map((s) => String(s || '').trim()).filter(Boolean),
      benefits: (form.benefits || [])
        .map((b) => ({ title: String(b.title || '').trim(), desc: String(b.desc || '').trim() }))
        .filter((b) => b.title),
    }
    await Api.savePartnerTier(payload)
    visible.value = false
    message.success('保存成功')
    await load()
  } finally {
    saving.value = false
  }
}

const remove = async (id?: number) => {
  if (!id) return
  await message.delConfirm()
  await Api.deletePartnerTier(id)
  message.success('已删除')
  await load()
}

onMounted(load)
</script>
